<template>
  <v-navigation-drawer
    class="accent-4 left-menu"
    permanent
    color="rgb(41, 49, 64)"
    fixed
  >
    <v-list
      expand
      v-if="$store.state.userInfo"
    >
      <fragment
        v-for="(item, index) in menu"
        :key="index"
      >
        <!--2차메뉴가 있는경우-->
        <v-list-group
          :prepend-icon="item.icon"
          v-model="item.active"
          v-if="item.subMenu"
        >
          <template v-slot:activator>
            <v-list-item-content
              :class="{'is--disabled': item.disabled || ($store.state.userInfo && !$store.state.userInfo[item.authRead])}"
              :disabled="item.disabled || ($store.state.userInfo && !$store.state.userInfo[item.authRead])"
            >
              <v-list-item-title>{{item.title}}</v-list-item-title>
            </v-list-item-content>
          </template>
          <fragment
            v-for="(sub, i) in item.subMenu"
            :key="i"
          >
            <v-list-group
              :prepend-icon="sub.icon"
              value="true"
              link
              v-if="sub.subSubMenu"
            >
              <template v-slot:activator>
                <v-list-item-content
                  :class="{'is--disabled': sub.disabled || ($store.state.userInfo && !$store.state.userInfo[sub.authRead])}"
                  :disabled="sub.disabled || ($store.state.userInfo && !$store.state.userInfo[sub.authRead])"
                >
                  <v-list-item-title>{{ sub.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <!--3차메뉴가 있는경우-->
              <template v-if="sub.subSubMenu">
                <v-list-item
                  v-for="(subItem, i) in sub.subSubMenu"
                  :key="subItem+i"
                  link
                  :to="subItem.path"
                  active-class="is--active"
                  :class="{'is--disabled': subItem.disabled || ($store.state.userInfo && !$store.state.userInfo[subItem.authRead])}"
                  :disabled="subItem.disabled || ($store.state.userInfo && !$store.state.userInfo[subItem.authRead])"
                >
                  <v-list-item-icon>
                    <v-icon class="material-icons-outlined" v-text="subItem.icon"></v-icon>
                  </v-list-item-icon>
                  <v-list-item-title v-text="subItem.title"></v-list-item-title>
                </v-list-item>
              </template>
              <!--3차메뉴가 있는경우-->
            </v-list-group>
            <v-list-item
              v-else
              link
              :to="sub.path"
              active-class="is--active"
              :class="{'is--disabled': sub.disabled  || ($store.state.userInfo && !$store.state.userInfo[sub.authRead])}"
              :disabled="sub.disabled || ($store.state.userInfo && !$store.state.userInfo[sub.authRead])"
            >
              <v-list-item-icon>
                <v-icon class="material-icons-outlined" v-text="sub.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-title v-text="sub.title"></v-list-item-title>
            </v-list-item>
          </fragment>
        </v-list-group>
        <!--1차메뉴만 있는경우-->
        <v-list-item
          v-else
          link
          :to="item.path"
          active-class="is--active"
          :class="{'is--disabled': item.disabled || ($store.state.userInfo && !$store.state.userInfo[item.authRead] && (item.path === '/manager' && !$store.state.userInfo.readBus))}"
          :disabled="item.disabled || ($store.state.userInfo && !$store.state.userInfo[item.authRead] && (item.path === '/manager' && !$store.state.userInfo.readBus))"
        >
          <v-list-item-icon>
            <v-icon class="material-icons-outlined" v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item>
      </fragment>
    </v-list>
    <p v-else class="unauthorized--text">권한이 없습니다.</p>
  </v-navigation-drawer>
</template>

<script>
import principal from '../../utils/principal'
import menu from '../../config/menu.json'

export default {
  data () {
    return {
      menu,
      isShowValue: true
    }
  },
  methods: {
    changeShowValue () {
    }
  },
  created () {
    try {
      const _auth = principal.getPrincipal()
      if (!_auth) {
        const redirect = encodeURIComponent(this.$route.fullPath)
        window.location.href = '/#/admin/login?redirect=' + redirect
        return
      }
      const userId = principal.getUserId()
      this.$store.dispatch('fetchId', userId)
    } catch (e) {
      principal.removePrincipal()
      const redirect = encodeURIComponent(this.$route.fullPath)
      window.location.href = '/#/admin/login?redirect=' + redirect
    }
  }
}
</script>

<style lang="scss">
.theme--light {
  &.left-menu {
    margin-top: 70px;
    z-index: 200;
    .v-list-item__icon:first-child {
      margin-right: 10px;
    }
    .v-list{
      .v-list-item {
        padding: 0 10px;
        &.is--disabled {
          opacity: 0.3;
        }
      }
      .v-list-group__items .v-list-item {
        &.is--disabled {
          opacity: 0.3;
        }
        padding: 0 27px;
      }
      .v-list-group .v-list-group__items {
        .v-list-group .v-list-group__items .v-list-item {
          padding: 0 43px;
        }
      }
      .v-list-item__title {
        font-size: 0.95rem;
        letter-spacing: -0.5px;
      }
    }

    .v-list-group {
      margin-bottom: 10px;
      .v-list-item__title  + .v-list-item__icon {
        color: rgb(129, 146, 161);
      }
    }
    .v-list-item {
      color: rgb(129, 146, 161) !important;
      padding: 0 26px;
      .v-list-item__icon {
        color: #598fad;
        margin: 10px 10px 10px 0;
        .v-icon {
          color: inherit;
        }
      }
      .v-list-item__content + .v-list-item__icon {
        color: rgb(129, 146, 161);
      }
      .v-list-item__title {
        color: rgb(129, 146, 161);
      }
      &.is--active {
        &.v-list-item--link:before {
          background: #1a212f;
          opacity: 1;
        }
        .v-list-item__icon {
          .v-icon {
            color: #598fad;
          }
        }
        .v-list-item__title {
          color: rgb(101, 178, 214);
          z-index: 11;
        }
      }
    }
    .v-list-item--link:before {
      /*background: #f5f5f5;*/
    }
    .v-list-group--active {
      .v-list-group__header__prepend-icon .v-icon {
        color: #598fad;
      }
      .v-list-group__header {
        .v-list-item__title {
          color: rgb(129, 146, 161);
        }
      }
    }
  }
}

.v-list-item__icon {
  .v-icon {
    color: #c1c1c1;
  }
}
.v-list-item__title {
  color: #5d5d5d;
}

</style>
